export const messages = {
  en: {
    communitySpaceConfirm: {
      page: {
        title: 'Space Write-off',
        subtitle: 'Scan venue codes to write off bookings and review write-off records',
        empty: 'No write-off records',
        loadFailed: 'Failed to load write-off list, please retry',
        tip: 'Scan protocol: ORDER:<payment order no.> writes off a whole order, TIME:<timeId> writes off a single booking'
      },
      scan: {
        title: 'Scan & Write Off',
        tip: 'Use a barcode scanner, or enter the code manually and press Enter'
      },
      list: {
        title: 'Write-off Records'
      },
      writeOff: 'Write Off',
      writeOffPlaceholder: 'Please scan with barcode scanner to write off',
      writeOffResult: 'Write Off Result',
      writeOffTime: 'Write Off Time',
      space: 'Space',
      appointmentDate: 'Appointment Date',
      appointmentHours: 'Appointment Hours',
      appointmentPerson: 'Appointment Person',
      appointmentPhone: 'Appointment Phone',
      searchCondition: 'Search Conditions',
      search: 'Search',
      reset: 'Reset',
      writeOffOrder: 'Write Off Order',
      venue: 'Venue',
      appointmentTime: 'Appointment Time',
      remark: 'Remark',
      personNamePlaceholder: 'Enter appointment person name',
      personTelPlaceholder: 'Enter appointment phone',
      appointmentTimePlaceholder: 'Select appointment time',
      scanTip: 'Please scan barcode first',
      writeOffSuccess: 'Write off successful',
      writeOffFailed: 'Write off failed'
    }
  },
  zh: {
    communitySpaceConfirm: {
      page: {
        title: '场地核销',
        subtitle: '扫码核销场地预约，并查询历史核销记录',
        empty: '暂无核销记录',
        loadFailed: '核销列表加载失败，请重试',
        tip: '扫码协议：ORDER:<支付单号> 为整单核销，TIME:<timeId> 为单条预约核销'
      },
      scan: {
        title: '扫码核销',
        tip: '使用扫码枪扫码，或手工输入编码后按回车'
      },
      list: {
        title: '核销记录'
      },
      writeOff: '核销',
      writeOffPlaceholder: '请扫码枪扫码核销',
      writeOffResult: '核销结果',
      writeOffTime: '核销时间',
      space: '场地',
      appointmentDate: '预约日期',
      appointmentHours: '预约小时',
      appointmentPerson: '预约人',
      appointmentPhone: '预约电话',
      searchCondition: '查询条件',
      search: '查询',
      reset: '重置',
      writeOffOrder: '核销订单',
      venue: '场馆',
      appointmentTime: '预约时间',
      remark: '备注',
      personNamePlaceholder: '请输入预约人',
      personTelPlaceholder: '请输入预约电话',
      appointmentTimePlaceholder: '请选择预约时间',
      scanTip: '请先扫码',
      writeOffSuccess: '核销成功',
      writeOffFailed: '核销失败'
    }
  }
}